import { lazy, memo, Suspense } from 'react';

import { ErrorBoundaryWithRetry } from '@/_components';

import { Loading } from './loading';
import type { ViewLogSectionProps } from './types';

const ViewLog = lazy(() => import('./view-log'));

function ViewLogSectionBase(props: ViewLogSectionProps) {
  return (
    <ErrorBoundaryWithRetry>
      <Suspense fallback={<Loading />}>
        <ViewLog {...props} />
      </Suspense>
    </ErrorBoundaryWithRetry>
  );
}

export const ViewLogSection = memo(ViewLogSectionBase);
